/**
 * Scroll the highlighted order row into view when arriving from a deeplink.
 * The row gains .order--highlighted if ?order_id= in the URL matches its data-order-id.
 */
document.addEventListener('DOMContentLoaded', function () {
  const row = document.querySelector('.order--highlighted');
  if (row) {
    row.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
});
